'use client';

import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { useCurrentMarketStepSize } from 'src/hooks/useMarketStepSize';
import useGetOraclePriceForMarket from 'src/hooks/useGetOraclePriceForMarket';
import useMarkPrice from 'src/hooks/useMarkPrice';
import { useTradeFormSyncSizeValues } from './useTradeFormSyncSizeValues';
import { useSyncResetTradeForm } from './useSyncResetTradeForm';
import { useSyncTradeFormOnOrderTypeChange } from './useSyncTradeFormOnOrderTypeChange';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { useShallow } from 'zustand/react/shallow';
import { UIMarket } from '@velocity-exchange/common';

const useTradeFormInputStateEngine = () => {
	const selectedMarket = useDriftStore((s) => s.selectedMarket.current);
	const selectedMarketId = useDriftStore((s) => s.selectedMarket.marketId);
	const stepSize = useCurrentMarketStepSize();
	const markPrice = useMarkPrice(selectedMarketId);
	const getOraclePrice = useGetOraclePriceForMarket();
	const oraclePrice = getOraclePrice(selectedMarketId);

	const {
		tradeSide,
		leadSide,
		quoteSizeStringValue,
		baseSizeStringValue,
		priceBoxStringValue,
		secondaryPriceBoxStringValue,
		orderType,
	} = useDriftStore(
		useShallow((s) => ({
			tradeSide: s.tradeForm.side,
			quoteSizeStringValue: s.tradeForm.quoteSizeStringValue,
			baseSizeStringValue: s.tradeForm.baseSizeStringValue,
			priceBoxStringValue: s.tradeForm.priceBoxStringValue,
			secondaryPriceBoxStringValue: s.tradeForm.secondaryPriceBoxStringValue,
			leadSide: s.tradeForm.leadSide,
			orderType: s.tradeForm.orderType,
		}))
	);

	const currentPosition = useDriftAccountStore((s) =>
		s
			.getCurrentUserAccount()
			?.client?.getUserAccount()
			?.perpPositions?.find(
				(pos) => pos.marketIndex === (selectedMarketId?.marketIndex as number)
			)
	);
	const currentUserAccountKey = useDriftAccountStore(
		(s) => s.getCurrentUserAccount()?.userKey as string
	);

	useTradeFormSyncSizeValues({
		oraclePrice,
		markPrice,
		orderType,
		priceBoxStringValue,
		secondaryPriceBoxStringValue,
		leadSide,
		baseSizeStringValue,
		quoteSizeStringValue,
		stepSize,
		tradeSide,
		currentPosition,
		selectedMarket: selectedMarket as UIMarket,
	});

	useSyncResetTradeForm(selectedMarketId?.key, currentUserAccountKey);

	useSyncTradeFormOnOrderTypeChange({
		orderType,
		baseSizeStringValue,
		quoteSizeStringValue,
	});
};

export default useTradeFormInputStateEngine;
